// NoDataBadge.tsx
import { Badge } from "@/components/ui/badge";
import { CircleSlash } from "lucide-react";

type Props = {
	label?: string;
	className?: string;
};

export function NoDataBadge({ label = "No data", className = "" }: Props) {
	return (
		<Badge
			variant="secondary"
			aria-label={label}
			className={[
				"inline-flex items-center gap-1.5 px-2 py-0.5",
				"text-[10px] leading-none",
				"bg-muted text-muted-foreground border border-border",
				className,
			].join(" ")}
		>
			<CircleSlash className="h-3.5 w-3.5 shrink-0" />
			{label}
		</Badge>
	);
}
